import { __assign, __extends } from "tslib";
import Element from './base';
import SizeController from './controller/size';
import KLineShapeFactory from './shape/k-line';
var KLine = /** @class */ (function (_super) {
    __extends(KLine, _super);
    function KLine(cfg) {
        var _this = _super.call(this, __assign({ type: 'kline', shapeType: 'kline', generatePoints: true }, cfg)) || this;
        var sizeController = new SizeController(_this);
        _this.set('sizeController', sizeController);
        _this.set('shapeFactory', KLineShapeFactory);
        return _this;
    }
    KLine.prototype.createShapePointsCfg = function (obj) {
        var cfg = _super.prototype.createShapePointsCfg.call(this, obj);
        cfg.size = this.getNormalizedSize(obj);
        return cfg;
    };
    return KLine;
}(Element));
export default KLine;
//# sourceMappingURL=k-line.js.map